import React from 'react';
import { scenarios } from '../../data/scenarios';
import { useProto } from '../../contexts/PrototypeContext';
import { SystemStatePanel } from './SystemStatePanel';
import type { Scenario } from '../../types/volunteer';
const groups: {
  id: Scenario['group'];
  title: string;
}[] = [{
  id: 'connect',
  title: 'Connect · franchisee setup'
}, {
  id: 'mobile',
  title: 'Registration · mobile'
}, {
  id: 'desktop',
  title: 'Registration · desktop'
}];
export function ScenarioPanel() {
  const {
    state,
    actions
  } = useProto();
  return <aside aria-label="Prototype scenarios" className="flex w-[300px] shrink-0 flex-col overflow-y-auto border-r border-proto-line bg-white font-proto" data-id="element-404" data-mp="2y4kx232m8tkw">
      <nav className="space-y-5 px-3 py-4" data-id="element-405" data-mp="37uebrcy21otd">
        {groups.map(g => <div key={g.id} data-id="element-406" data-mp="37vpbn1odqcf7">
            <h2 className="px-2.5 pb-1.5 text-xs font-semibold text-proto-muted" data-id="element-407" data-mp="2af0cjfqtdo9i">{g.title}</h2>
            <ul className="space-y-0.5" data-id="element-408" data-mp="2fd1we2w2drm1">
              {scenarios.filter(s => s.group === g.id).map(s => {
            const active = state.activeScenario === s.id;
            return <li key={s.id} data-id="element-409" data-mp="9rp7jxxnnfd8">
                      <button type="button" onClick={() => actions.applyScenario(s.id)} aria-current={active ? 'true' : undefined} className={`flex w-full gap-2.5 rounded-md px-2.5 py-2 text-left transition-colors duration-150 ${active ? 'bg-proto-selected' : 'hover:bg-proto-hover'}`} data-id="element-410" data-mp="50h037fvy42p">
                        <span className={`mt-0.5 flex h-5 min-w-[22px] items-center justify-center rounded px-1 text-[11px] font-semibold tabular-nums ${active ? 'bg-proto-accent text-white' : 'bg-proto-chip text-proto-ink'}`} data-id="element-411" data-mp="3i7ip8g3q2wvv">
                          {s.outputs}
                        </span>
                        <span className="min-w-0" data-id="element-412" data-mp="35vgco3febxwu">
                          <span className="flex items-center gap-1.5 text-[13px] font-medium text-proto-ink" data-id="element-413" data-mp="3anzrt4tqf13r">
                            <span className="truncate" data-id="element-414" data-mp="2vzd2caae4syt">{s.title}</span>
                            {s.state && <span className="shrink-0 rounded border border-proto-line bg-white px-1 text-[10px] font-semibold text-proto-muted" data-id="element-415" data-mp="30yg5tqaq2r4o">
                                {s.state}
                              </span>}
                          </span>
                          <span className="block text-xs leading-snug text-proto-muted" data-id="element-416" data-mp="3flj3py2yj1sj">{s.description}</span>
                        </span>
                      </button>
                    </li>;
          })}
            </ul>
          </div>)}
      </nav>
      <SystemStatePanel data-id="element-417" data-mp="289iopqi8z0di" />
    </aside>;
}